export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_139_EVALUATIONS': 'Evaluations',
    '_10021_CREATE_NEW_EVALUATION': 'Create New Evaluation',
    '_10022_SEARCH_EVALUATIONS': 'Search Evaluations',
    '_10023_MY_EVALUATIONS': 'My Evaluations',
    '_10024_EVALUATIONS_CREATED_FOR_ME': 'Evaluations Created For Me',
    '_10025_EVALUATIONS_CREATED_BY_ME': 'Evaluations Created By Me',
    '_10026_EVALUATIONS_CREATED_FOR_MY_TEAM': 'Evaluations Created For My Team',
    '_830_DAY': 'Day',
    '_7471_TEAM': 'Team',
    '_10027_TEAM_SUBORDINATES': 'Team + Subordinates',
    '_4130_SHOW_ALL': 'Show all',
    '_10028_SHOW_LESS': 'Show less',
    '_9999_EVENT_DATE': 'Event Date',
    '_10029_EVALUATION_ID': 'Evaluation ID',
    '_102_USER_NAME': 'User Name',
    '_48_MANAGER': 'Manager',
    '_10030_EVALUATOR': 'Evaluator',
    '_9998_EVALUATION_NAME': 'Evaluation Name',
    '_752_SCORE': 'Score',
    '_127_STATUS': 'Status',
    '_710_SEARCH': 'Search',
    '_9476_DRAFT': 'Draft',
    '_9113_PUBLISHED': 'Published',
    '_789_VIEW': 'View',
    '_7425_EDIT': 'Edit',
    '_10031_NO_EVALUATIONS_TO_DISPLAY_FOR_THE_SELECTED_TIME_PERIOD': 'No evaluations to display for the selected time period',
    '_9395_RESET_GRID': 'Reset Grid'
};
